import {InjectionToken, signal, WritableSignal} from '@angular/core';

export const AUTH_TOKEN = new InjectionToken<WritableSignal<string | null>>('AUTH_TOKEN', {factory: () => signal<string | null>(null)});

export const ENDPOINT_DOMAIN = new InjectionToken<string | null>('ENDPOINT_DOMAIN');
export const ENDPOINT_DOMAIN_API = new InjectionToken<string | null>('ENDPOINT_DOMAIN_API');
export const ENDPOINT_DOMAIN_FORM = new InjectionToken<string | null>('ENDPOINT_DOMAIN_FORM');
